import mainline from './mainline';
import workflow from './workflow';
import core from './core';
import details from './details';

const drbfm = {
  mainline,
  workflow,
  ...core,
  ...details,
};

export default drbfm;
